
import React from "react";

function CustomAlert({ alertData, onStop }) {
  if (!alertData) return null;

  // Dynamic background color based on alert type
  const bgColor = {
    red: "#d9534f",
    orange: "#f0ad4e",
    yellow: "#f7e463"
  }[alertData.type || "red"]; // fallback to red

  const isLight = alertData.type === "yellow";

  return (
    <div className="custom-alert"  style={{
      backgroundColor: bgColor,
      color: isLight ? "#000" : "#fff",
      padding: "24px 28px",
      zIndex:"9999",
      borderRadius: "10px",
      boxShadow: "0 6px 14px rgba(0,0,0,0.35)",
      width: "360px",
      minHeight: "180px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between"
    }}>
      <div>
        <h4 style={{ margin: "0 0 8px" }}>{alertData.deviceName}</h4>
        <p style={{ fontSize: "16px", margin: 0 }}>{alertData.message}</p>
      </div>
      <button
        style={{
          alignSelf: "flex-end",
          marginTop: "20px",
          backgroundColor: isLight ? "#000" : "#fff",
          color: isLight ? "#fff" : bgColor,
          border: "none",
          borderRadius: "4px",
          padding: "8px 14px",
          cursor: "pointer",
          fontWeight: "bold"
        }}
        onClick={onStop}
      >
        Stop
      </button>
    </div>
  );
}

export default CustomAlert;
